const ar = {
  home: 'Home',
  najizPlatform: 'Najiz Portal',
  judicalEServices: 'The Unified Platform for Electronic Judicial Services',
  enter: 'Enter',
  noServicesFoundPleaseTryAgain: 'No services found.',
  new: 'New',
  modified: 'Updated',
  redirectToService: 'Go to Service',
  businessAccountActivationRequirements: 'Key Requirements to Activate Business Account',
  accountValidityPeriod: 'Account validity period',
  fromActivationDate: 'From activation date',
  accountCreationFees: 'Account creation fees',
  activateFirstOrganizationAccountText: 'Activate the first account of the organization',
  activateFirstOrganizationAccountDescription: 'Additional accounts will be charged.',
  fees: 'fees',
  free: 'free',
  sar: 'SAR',
  year: 'Year',

  verificationServices: {
    title: 'Verification Services',
    description: 'This service enables users to verify documents issued by the MOJ electronically',
    userNeed: 'I want to verify',
    browseVerificationServices: 'Browse Verification Services',
  },

  appInsights: {
    verificationServicesArName: 'Verification Services',
  },

  serviceUsage: 'e-Services',
  mostUsed: 'Most Used',
  serviceExplaination: 'Service explaination',
  najizData: 'Najiz data',
  last7Days: 'Viewed data for the last 7 days',
  najizDataDescription: 'The optimal solution to access reliable data and create new business opportunities',
  najizDataLogin: 'Login to Najiz Data',
  scrollForMore: 'Scroll for more',
  najizInNumbers: 'Najiz in figures',

  services: {
    title: 'e-Services',
    explaination: 'Service Explaination',
    browseAllServices: 'Browse all services',
    searchInServices: 'Find a service',
    prominentServices: 'Featured e-Services',
    browseAll: 'Browse All',
    categoriesLabel: 'Service Categories',
  },

  licenseType: 'License type',
  chooseLicenseType: 'Select License Type',
  iWantToPreview: 'View Directory',
  email: 'Email',
  withMaxLengthChars: 'Maximum {length} characters',

  contactWithUs: {
    title: 'Contact Us',
    slogan: 'We\'re here to serve you and you can contact us anytime',
    contactInsideKSA: 'Contact Us from Within the Kingdom',
    fromSunToThurs: 'Sunday to Thursday',
    fromInsideKSA: 'From Within the Kingdom of Saudi Arabia',
    contactUs: 'Contact Us',
    contactOutsideKSA: 'Call Us from Outside the Kingdom',
    contactTime: 'From 8 AM to 2:15 PM (Sunday - Thursday)',
    fromOutsideKSA: 'From Outside the Kingdom of Saudi Arabia',
    messageUs: 'Message Us',
    allWeekDays: 'All Days of the Week',
    allTheTime: 'All Times',
    instantChat: 'Instant Chat',
    chatWithUs: 'Chat with Us',
    pleaseToServeYou: 'We\'re happy to At your service at all Najiz centers.',
    najizCenterRiyadhBranch: 'Najiz Center, Riyadh Branch',
    najizCenterRiyadhBranchLocation: 'Anas Ibn Malik Road, Al Malqa, Riyadh 13524',
    location: 'Location',
    workingDays: 'Working Days',
    workingTime: 'Working Times',
    from: 'From',
    until: 'Until',
    atMorning: 'Amongst',
    atNight: 'Evening',
    najizCenterJeddahBranch: 'Najiz Center, Jeddah Branch',
    najizCenterJeddahBranchLocation: 'Sari, Al Khalidiyah District, Jeddah 23423',
    najizCenterDammamBranch: 'Najiz Center, Dammam Branch',
    najizCenterDammamBranchLocation: 'Dhahran-Jubail Expressway, Al Rawdah, Dammam',
    socialMediaAccounts: 'Social Media Accounts Social',
    x: 'X',
    instagram: 'Instagram',
    snapchat: 'Snapchat',
    youtube: 'YouTube',
    facebook: 'Facebook',
    linkedin: 'LinkedIn',
    contactChannels: 'Channels for receiving inquiries and complaints',
    name: 'Name',
    enterTheName: 'Enter Name',
    email: 'Email',
    emailPlaceholder: 'Example@email.com',
    phone: 'Mobile Number',
    phonePlaceholder: '05xxxxx',
    messageTitle: 'Message Subject',
    messageTitlePlaceholder: 'Enter Message Subject',
    messageCategory: 'Message Category',
    messageText: 'Message Text',
    theMessage: 'Message',
    send: 'Send',
    serviceAvailability: 'Service Availability',
    contactNumber: 'Contact Number',
    responseTime: 'Response Time',
    instant: 'instant',
    serviceType: 'Service Type',
    liveChat: 'Live Chat',
    inquiriesAndComplaints: 'Inquiries and Complaints',
    supportWithSignLanguage: 'Sign Language Support',
    tenDaysWork: '10 Working Days',
    twoWorkDays: 'Two Working Days',
    judicialContact: 'Judicial Communication',
    signSupport: 'Sign Support',
    question: 'Question',
    suggestion: 'Suggestion',
    help: 'Help',
    messageSentSuccessfully: 'Message Sent Successfully',
    contactSample: 'Contact Sample',
  },

  validations: {
    fieldIsRequired: 'This field is required',
    onlyNumbers: 'Please enter only numbers',
    maxInputsLength: 'The maximum number of inputs is {length}',
    numbersExactLength: 'The number of numbers must be {length}',
    startsWith: 'Must start with {listText}',
    phoneNumber: 'The mobile number must begin with {key} and be {length} numbers',
    emailAddress: 'Please enter a valid email address',
    onlyArabicAndNumbers: 'Please enter only Arabic letters and numbers.',
    onlyArabicOrNumbers: 'Please enter only Arabic letters or numbers.',
    specialCharacters: 'Please do not enter special characters.',
    twitterId: 'The username must be http(s)://twitter.com/xyz123',
    facebookId: 'The username must be http(s)://facebook.com/xyz123',
    minWordsLength: 'The minimum number of words must be {length}',
    theNameMustBeBinary: 'The name must be binary',
    onlyArabic: 'You must enter only Arabic characters',
    duplicatePhoneNumberInContactInfo: 'The number of the first person must not match the number of the second person',
    duplicatePhoneNumberInApplicantInfo: 'The mobile number must not match the mobile number in your personal information.',
    alphaNumeric: 'Please enter only English letters and numbers.',
    alphaNumericAndSpecialChars: 'Please enter English letters, numbers, and special characters such as {chars}.',
  },

  faqs: {
    title: 'FAQs',
    searchPlaceholder: 'Search (e.g: How to draft a statement of claim)',
    howCanWeHelpYou: 'How can we help you?',
    browseAllQuestions: 'Browse All Questions',
    noQuestionsAvailable: 'No Questions available',
    shareQuestion: 'Share Question ',
    questionLinkCopiedSuccessfully: 'Link copied successfully',
    questionDetails: 'Question Details',
    commonFaqs: 'FAQs',
    commonQuestions: 'FAQs',
    questionDetailsNotAvailable: 'Question details are not available',
    filterByCategory: 'Filter by category',
  },

  najizPartners: 'Najiz partners',

  contactUs: {
    title: 'Contact Us',
    forMoreContacts: 'More Contact Channels',
  },
  mobileApplication: {
    title: 'Najiz app',
    downloadAvailability: 'Download the Najiz App',
    devicesText: 'For Android and iPhone devices',
  },

  useTheService: 'Use the service',
  startTheService: 'Start Service',
  serviceDescription: 'Service description',
  serviceRequirements: 'Service requirements',
  stepsToApplyForTheService: 'Steps to Apply for the Service',
  submitNewRequest: 'Submit New Request',
  followUpOnPreviousRequest: 'Track Previous Request',
  authenticationOfCompletedRequest: 'Authenticate of Completed Request',
  serviceVideoExplaination: 'The Service Video',
  serviceProviderChannels: 'Service Channels',
  youShouldKnow: 'Please note',
  fetchingData: 'Loading Data',
  searchResult: 'Search result',
  searchResults: 'Search results  ({searchText})',
  browseService: 'Browse service',
  noSearchResultsFound: 'No search results matching entered data',
  noSearchResultsMessage: 'Please verify the data and try again.',

  login: 'Log in',
  activateBusinessAccount: 'Activate business account',
  individuals: 'Individuals',
  businesses: 'Businesses',
  government: 'Government',
  lawyers: 'Lawyers',
  individualsLoginMsg: 'Login for citizens, residents, and visitors',
  governmentLoginMsg: 'Login for representatives of government agencies',
  lawyersLoginMsg: 'Login for Lawyers Licensed by the MOJ',
  businessesLoginMsg: 'Login for owners and representatives of companies, institutions and public benefit facilities',
  forMoreDetails: 'For more Details',
  requiredDocuments: 'Required Documents',
  serviceExecutionTime: 'Service Processing Time',
  instant: 'Instant',
  serviceExecutionTimeDescription: 'From {from} - To {to}',
  beneficiaries: 'Beneficiaries',
  serviceFees: 'Service Fees',
  commonFaqs: 'FAQs',
  checkFaqs: 'View FAQs',
  clickHere: 'Click Here',
  signalSupport: 'Sign Language Support',
  signalCustomerSupport: 'Sign Language Technical Support',
  allServices: 'All Services',
  downloadApp: 'Download App',
  usageGuide: 'User Guide',
  downloadUsageGuide: 'Download User Guide',
  theDescription: 'Description',
  theRequirements: 'Requirments',
  theSteps: 'Steps',
  share: 'Share',
  serviceLinkCopiedSuccessfully: 'Service Link copied successfully',
  loginToCreateAccount: 'login to create account',

  sessionsAttendence: 'Attend Sessions',
  ePayment: 'e-Payment',
  executionRequestActions: 'Procedures of Enforcement Request',
  virtualCourtExecutionRequest: 'Virtual Court Enforcement Request',
  nowFromApp: 'Now Via the App',
  downloadAppNow: 'Download the App Now',

  serverErrors: {
    USER_NOT_FOUND: 'User is not found, please try again',
    INVALID_DATA: 'INVALID DATA, please try again',
    SERVER_ERROR: 'System Error. Please try again later',
  },

  najizCenter: {
    about: {
      title: 'About Najiz Center',
      description: 'Najiz Center is a model judicial center under the National Transformation Program, aimed at improving the experience of beneficiaries and serving the business sector. It provides all Ministry of Labor services with ease and reliability through four main pathways: ',
      categories: 'Judiciary, Execution, Documentation, and Interest.',
      vision: {
        title: 'Vision',
        content: 'To be the leading model in providing advanced and comprehensive operational services that meet the needs of beneficiary sectors.',
      },
      mission: {
        title: 'Mission',
        content: 'To deliver an exceptional beneficiary journey through an efficient operational experience, trustworthy relationships, and organized working hours that achieve satisfaction for both individuals and the business sector.',
      },
      objectives: {
        title: 'Objectives',
        items: {
          item1: 'Ensure service quality',
          item2: 'Save time and effort',
          item3: 'Enhance beneficiary satisfaction',
        },
      },
    },
    services: {
      title: 'Services',
      description: 'Najiz Center provides all modern services on behalf of beneficiaries by processing transactions electronically to ensure speed and accuracy, saving time and effort.',
    },

    stats: {
      title: 'Najiz Center in Numbers',
      figures: {
        beneficiaries: {
          value: 'million',
          label: 'beneficiaries',
        },
        serviceTime: {
          value: 'minutes',
          label: 'average service delivery time',
        },
        satisfaction: {
          label: 'beneficiary satisfaction rate',
        },
      },
    },

    branches: {
      title: 'Najiz Center Branches',
      description: 'Najiz Center has a network of branches across various regions of the Kingdom to facilitate beneficiaries\' access to judicial services.',
      locations: {
        workingHours: 'Working hours: Sunday to Thursday,',
        name: 'Najiz Center',
        mapLink: 'View location on map',
        morning: 'Morning',
        evening: 'Evening',
      },
    },

    fixedSidebar: {
      onThisPage: 'On this page',
      najizCenter: 'Najiz Center',
      about: 'About Najiz Center',
      services: 'Services',
      judiciary: 'Judiciary',
      enforcement: 'Enforcement',
      documentation: 'Documentation',
      reconciliation: 'Reconciliation',
      stats: 'Najiz Center in Numbers',
      branches: 'Najiz Center Branches',
    },
  },

  governmentalAccountActivation: 'Activate Government Account',
  businessAccountActivation: 'Activate Business Account',
  governmentalAccountActivationRequirements: 'Governmental Account Activation Requirements',
  activateGovernmentAccount: 'Activate Government Account',
  noFees: 'No Fees',

  // Accessibility
  skipToMainContent: 'Skip to main content',
  nationalDayLogo: 'National Day Logo',
  hayyakumAllahLogo: 'Hayyakum Allah ',
  najizAppLogo: 'Najiz App Logo',
  downloadFromAppStore: 'Download from App Store',
  downloadFromGooglePlay: 'Download from Google Play',
  loginTo: 'Login to',
  visitPartner: 'Visit',

};

export default ar;
